// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3DpeU","inputWrap":"CustomTip_inputWrap__22ISU"};